import React from "react";

import BuidlerList from "../../../Components/GMS/Builder/BuilderList";

function BuilderList(props) {
  return <BuidlerList />;
}

export default BuilderList;
